<div id="mobileHeader">
  <div class="row">
    <div class="col-4">
      <img class="bidit-logo" alt="BiditWeb" src="assets/img/bidit_logo_mobile.png" />
    </div>
    <div class="col-8 header-label d-flex flex-column justify-content-center" i18n>CONSTRUCTION MANAGEMENT RESOURCE TOOL</div>
  </div>
  <div class="header-separator"></div>
</div>
